<script>
  import VTooltip from 'vuetify/es5/components/VTooltip'

  function _defineProperty (obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }) } else { obj[key] = value } return obj }

  export default {
    name: 'tutorial-tooltip',
    extends: VTooltip,
    props: {
      maxWidth: {
        type: [Number, String],
        default: 300
      },
      openOnHover: {
        type: Boolean,
        default: false
      }
    },
    render (h) {
      var _addBackgroundColorCl = {}

      var tooltip = h('div', {
        staticClass: 'v-tooltip__content',
        'class': this.addBackgroundColorClassChecks((_addBackgroundColorCl = {}, _defineProperty(_addBackgroundColorCl, this.contentClass, true), _defineProperty(_addBackgroundColorCl, 'menuable__content__active', this.isActive), _addBackgroundColorCl)),
        style: this.styles,
        attrs: this.getScopeIdAttrs(),
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        ref: 'content'
      }, this.showLazyContent(this.$slots.default))
      return h(this.tag, {
        staticClass: 'v-tooltip',
        'class': this.classes
      }, [h('transition', {
        props: {
          name: this.computedTransition
        }
      }, [tooltip]), h('span', {
        on: this.disabled ? {} : {
        },
        ref: 'activator'
      }, this.$slots.activator)])

      /* const tooltip = h('div', {
        staticClass: 'tooltip__content',
        'class': this.addBackgroundColorClassChecks({
          [this.contentClass]: true,
          'menuable__content__active': this.isActive
        }),
        style: this.styles,
        attrs: this.attrs,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        ref: 'content'
      }, this.$slots.default)
      return h(this.tag, {
        staticClass: 'tooltip',
        'class': this.classes
      }, [
        h('transition', {
          props: {
            name: this.computedTransition
          }
        }, [tooltip]),
        h('span', {
          on: this.disabled ? {} : {
          },
          ref: 'activator'
        }, this.$slots.activator)
      ]) */
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialTooltip.vue